import { getFirstDomainName } from './getFirstDomainName'

export const getRequestUrl = (tenant: { domain: string } | null, url: string): string => {
  const { protocol, hostname, pathname } = new URL(url)

  return tenant
    ? `${protocol}//${getFirstDomainName(tenant?.domain)}.${hostname}${pathname}`
    : url
}